import Home01 from './Home01'
import Home02 from './Home02'
import Home03 from './Home03'
import Home04 from './Home04'
import HomeAnimate from './HomeAnimate'
import CourseV1 from './CourseV1'
import CourseV2 from './CourseV2'
import CourseV3 from './CourseV3'
import CourseSingle from './CourseSingle'
import IntructorPage from './IntructorPage'
import EventV1 from './EventV1'
import EventV2 from './EventV2'
import EventSingle from './EventSingle'
import Faqs from './Faqs'
import AboutUs from './AboutUs'
import Shop from './Shop'
import ShopSingle from './ShopSingle'
import Blog from './Blog'
import BlogSingle from './BlogSingle'

const routes = [
    { path: '/', component: Home01},
    { path: '/home-02', component: Home02},
    { path: '/home-03', component: Home03},
    { path: '/home-04', component: Home04},
    { path: '/home-animate', component: HomeAnimate},
    { path: '/courses-grid-v1', component: CourseV1},
    { path: '/courses-grid-v2', component: CourseV2},
    { path: '/courses-grid-v3', component: CourseV3},
    { path: '/courses-single', component: CourseSingle},
    { path: '/instructors', component: IntructorPage},
    { path: '/event-v1', component: EventV1},
    { path: '/event-v2', component: EventV2},
    { path: '/event-single', component: EventSingle},
    { path: '/faq', component: Faqs},
    { path: '/about-us', component: AboutUs},
    { path: '/shop', component: Shop},
    { path: '/shop-single', component: ShopSingle},
    { path: '/blog', component: Blog},
    { path: '/blog-single', component: BlogSingle},
]

export default routes;